import React, { useContext, useState } from "react"
import { CenterPiece, Footer, Main, Previous } from "../styles"
import GameContext from "../../../Context/GameContext"
import { NextButton } from "../NextButton"
import { createHostAction } from "../createHostAction"
import { actions } from "../../shared/constants"
import { defaultLabels } from "../../shared/defaultLabels"
import ReactMarkdown from "react-markdown"
import { PlayersRedistribute } from "../players/PlayersRedistribute"

export const RoundRedistribute = props => {
  const { onAction, gameData } = useContext(GameContext)
  const [pendingConfirm, setPendingConfirm] = useState(false)
  const [pendingReset, setPendingReset] = useState(false)

  const handleResetRedistribute = () => {
    setPendingReset(true)
    onAction(createHostAction(actions.HOST_RESET_REDISTRIBUTE))
    setTimeout(() => {
      setPendingReset(false)
    }, 5000)
  }

  const handleConfirmRedistribute = () => {
    setPendingConfirm(true)
    onAction(createHostAction(actions.HOST_CONFIRM_REDISTRIBUTE))
  }

  const host_title =
    gameData?.round_redistribute?.host_title ||
    defaultLabels?.ROUND_REDISTRIBUTE_HOST_TITLE
  const description =
    gameData?.round_redistribute?.description ||
    defaultLabels?.ROUND_REDISTRIBUTE_HOST_DESCRIPTION
  const host_reset_button =
    gameData?.round_redistribute?.host_reset_button ||
    defaultLabels?.ROUND_REDISTRIBUTE_HOST_RESET_BUTTON
  const host_confirm_button =
    gameData?.round_redistribute?.host_confirm_button ||
    defaultLabels?.ROUND_REDISTRIBUTE_HOST_CONFIRM_BUTTON
  const descriptionLines = description.split("\n")

  return (
    <Main>
      <CenterPiece>
        <h1>{host_title}</h1>
        <div>
          {descriptionLines.map((line, index) => {
            return (
              <div key={index}>
                <ReactMarkdown>{line}</ReactMarkdown>
              </div>
            )
          })}
        </div>
      </CenterPiece>
      <Footer>
        <Previous
          onClick={handleResetRedistribute}
          children={host_reset_button}
          pending={pendingReset}
          disabled={pendingReset}
        />
        <PlayersRedistribute />
        <NextButton
          onClick={handleConfirmRedistribute}
          children={host_confirm_button}
          pending={pendingConfirm}
          disabled={pendingConfirm}
        />
      </Footer>
    </Main>
  )
}
